import styled from 'styled-components';
import _ApiList from 'components/grid/api-list';
import { Row } from 'components/layout';
import BackIcon from 'styles/icons/back.svg';
import { ReactComponent as ForwardIcon } from 'styles/icons/forward-icon.svg';
import { normalize } from 'utils/styles';
import { color, typography } from 'styles/settings';

export const FieldLabel = styled.span`
  ${typography.font.content.regular};
  font-size: ${typography.size.xs};
  color: ${color.neutral.plainBlack};
`;
export const FieldValue = styled.div`
  ${typography.font.content.semiBold};
  font-size: ${typography.size.md};
  color: ${color.neutral.plainBlack};
  max-width: 260px;
`;

export const RightArrowCircleIcon = styled(ForwardIcon)`
  background-color: ${color.brand.gold};
  border-radius: 100%;
  padding: 8px;
  cursor: pointer;
  height: ${normalize('22px')};
  width: ${normalize('22px')};
`;

export const HeaderControls = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 45px;

  @media all and (max-width: 1200px) {
    align-items: center;
    flex-direction: column;
    height: auto;
    justify-content: space-between;
    margin-bottom: 16px;
    margin-right: -16px;
    margin-left: 16px;
  }
`;

export const Header = styled(Row)`
  padding: 15px 20px;
`;

export const FullScreen = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${color.neutral.white};
`;

export const ApiList = styled(_ApiList)`
  height: 84%;
  display: flex;
  flex-direction: column;
  flex: 1 1 1px;
`;

export const Container = styled.div`
  margin: 0 15%;
  height: 100%;
`;

export const SearchContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const TabContainer = styled.div`
  @media all and (min-width: 1200px) {
    width: 60%;
    margin: auto;
  }
`;

export const BackButton = styled.a`
  align-self: flex-start;
  ${typography.font.content.semiBold};
  font-size: ${typography.size.sm};
  cursor: pointer;
  background-image: url('${BackIcon}');
  background-repeat: no-repeat;
  background-position: center left;
  background-size: 1em;
  padding-left: 1.5em;
  display: block;
  min-width: 200px;
  height: 28px;
  line-height: 28px;

  @media all and (max-width: 1200px) {
    display: none;
  }
`;
